import React from 'react';
// import AppProvider from "../../../Components/bootstrap"
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Card';
import { makeStyles } from "@material-ui/core/styles";
import { SelectInput } from 'react-admin';
import { useSlots } from "./../hooks"
import { DateInput } from "../../../Components/Pickers"
import moment from "moment"
import { useHistory } from 'react-router-dom'
// import useMediaQuery from "@material-ui/core/useMediaQuery";
// import Tabs from '@material-ui/core/Tabs';
// import Tab from '@material-ui/core/Tab';
// import Left from "../../../images/left.png"
// import Right from "../../../images/right.png"
// import Buttons from "../../../Screens/ScheduleAppointment/Components/schedule1Buttons"
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  DateClass: {
    width: "100%"
  }
}));

const Schedule = ({ handleSubmit,
  reset,
  submitting,
  pristine,
  values,
  props,
  form,
  ...rest }) => {
  const classes = useStyles()
  const { availableSlots } = useSlots(values.date)

  const history = useHistory();

  const handleAvailabilitySlotToggle = (selectedValue) => {
    const filteredSlots = values.selectedSlots.filter(selectedSlot => selectedSlot !== selectedValue.toJSON().objectId)
    if (filteredSlots.length === values.selectedSlots.length) {
      form.change('selectedSlots', [...values.selectedSlots, selectedValue.toJSON().objectId])
    } else {
      form.change('selectedSlots', filteredSlots)
    }
  }
  return (
    <form onSubmit={handleSubmit} noValidate>
      <Paper style={{ padding: "15px", boxShadow: "none", }}>

        <Grid container spacing="2" >
          <Grid item sm={3} xs={0}></Grid>
          <Grid item sm={3} xs={5}>
            <Typography varaint="body2" style={{ textAlign: "left", fontWeight: "600", fontSize: "18px", marginTop: "20px", }}>Select Date </Typography>
            <DateInput source="date" label="Date" initialValue={values.date} className={classes.DateClass} />
          </Grid>
          <Grid item sm={3} xs={5}>
            <Typography varaint="body2" style={{ textAlign: "left", marginTop: "20px", fontWeight: "600", fontSize: "18px", marginLeft: "5px" }}>Select Duration</Typography>

            <div >
              <SelectInput
                source="duration"
                fullWidth
                variant="standard"
                label="Select Duration"
                style={{ width: "100%", marginLeft: 5, marginTop: "20px" }}
                choices={[
                  { id: 30, name: "30 min meeting" },
                  { id: 60, name: "60 min meeting" },
                ]}
              >
              </SelectInput>
            </div>
          </Grid>
          <Grid item sm={3} xs={0}></Grid>

        </Grid>
        {/* <button type="submit" >Next</button> */}
      </Paper>

      <Paper style={{ padding: "15px", boxShadow: "none", }}>

        <Grid container  >
          <Grid item xs={3}>  </Grid>
          <Grid item xs={6} >
            <Typography variant="h6" style={{ textAlign: "center" }}>Select  Slot</Typography>
          </Grid>
          <Grid item xs={3}>  </Grid>

        </Grid>

        <Grid container style={{ marginTop: "15px" }}>
          <Grid item sm={3} xs={0}>  </Grid>
          <Grid item sm={7} xs={12} >
            {availableSlots.map((availableSlot, i) => (
              <Button key={i} color={values.selectedSlots.findIndex(selectedSlot => selectedSlot === availableSlot.toJSON().objectId) > -1 ? "primary" : 'default'} onClick={() => handleAvailabilitySlotToggle(availableSlot)} variant="outlined" style={{ margin: "10px", width: "95px" }}>{moment(availableSlot.get('slotTime')).format("DD-MM-YYYY HH:mm")}</Button>
            ))}
          </Grid>

        </Grid>


        <Grid container style={{ marginTop: "7vh" }}>
          <Grid item xs={6}>
            <Button
              style={{ background: "#D14002", color: "white", borderRadius: "5px", padding: "5px", width: "100px" }}
              onClick={() => { history.replace('/') }}
            >
              Cancel
              </Button>
          </Grid>
          <Grid item xs={6} >
            <Button
              disabled={values.selectedSlots.length === 0}
              type="submit"
              style={{ background: "#0288D1", color: "white", borderRadius: "5px", float: "right", padding: "5px  ", width: "90px" }}> Next</Button>
          </Grid>

        </Grid>
      </Paper>
    </form>
  );
  // }
  // else {
  //   return (
  //     <div className={classes.div}>
  //       <div    >
  //         <form onSubmit={handleSubmit} noValidate>
  //           <Paper style={{ boxShadow: "0px 0px 7px rgba(0, 0, 0, 0.32)", height: "70px", borderBottom: "1px rgba(0, 0, 0, 0.32) solid" }}>
  //             <Tabs
  //               value={value}
  //               // indicatorColor="primary"
  //               // textColor="primary"
  //               onChange={handleChange}
  //               aria-label="disabled tabs example"
  //               style={{ marginTop: "20px" }}
  //             >
  //               <img src={Left} alt="123mentor" style={{ height: "35px", width: "19px", marginLeft: "15px", }} />

  //               <Tab label="Today" style={{ marginLeft: "15px", marginTop: "-7px" }} />
  //               <Tab label="Tomorrow" style={{ marginLeft: "15px", marginTop: "-7px" }} />
  //               <Tab label="Mar, 31st" style={{ marginLeft: "15px", marginTop: "-7px" }} />
  //               <img src={Right} alt="123mentor" style={{ height: "35px", width: "19px", marginLeft: "15px", }} />

  //             </Tabs>

  //           </Paper>
  //           <Buttons />
  //         </form>
  //       </div>
  //     </div>
  //   );
  // }
}
export default Schedule;